import { render, staticRenderFns } from "./WlRegionDialog.vue?vue&type=template&id=1d1e63fa&scoped=true"
import script from "./WlRegionDialog.vue?vue&type=script&lang=js"
export * from "./WlRegionDialog.vue?vue&type=script&lang=js"
import style0 from "./WlRegionDialog.vue?vue&type=style&index=0&id=1d1e63fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1e63fa",
  null
  
)

export default component.exports